import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import HomePage from "./pages/HomePage";
import ReviewPage from "./pages/ReviewPage";
import ReviewsPage from "./pages/ReviewsPage";
import CategoriesPage from "./pages/CategoriesPage";
import EditorialPage from "./pages/EditorialPage";
import MovieDetailPage from "./pages/MovieDetailPage";
import AboutPage from "./pages/AboutPage";
import LoginPage from "./pages/LoginPage";
import BookmarksPage from "./pages/BookmarksPage";
import AuthCallback from "./pages/AuthCallback";
import StarsPage from "./pages/StarsPage";
import StarDetailPage from "./pages/StarDetailPage";
import SeriesPage from "./pages/SeriesPage";
import SeriesDetailPage from "./pages/SeriesDetailPage";

// Router component that handles session_id detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id DURING RENDER
  // This prevents race conditions by processing new session_id FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/review/:id" element={<ReviewPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/movie/:id" element={<MovieDetailPage />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="/categories/:category" element={<CategoriesPage />} />
      <Route path="/editorial" element={<EditorialPage />} />
      <Route path="/editorial/:id" element={<EditorialPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/bookmarks" element={<BookmarksPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/stars" element={<StarsPage />} />
      <Route path="/stars/:id" element={<StarDetailPage />} />
      <Route path="/series" element={<SeriesPage />} />
      <Route path="/series/:id" element={<SeriesDetailPage />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
